
import { stringConstants } from "../../constants/app-constants";
import sortByKey from "../helpers/sort-by-key";

export default (list) => {
    const all = sortByKey(list, "display_order", "desc");
    const popular = [];
    const luxury = [];
    const elite = [];

    for (let i = 0; i < all.length; i++) {
        const value = all[i];

        if (value.is_popular && value.is_popular.toLowerCase() === stringConstants.YES) {
            popular.push(value);
        }

        if (value?.luxuryCar) {
            luxury.push(value);
        }

        if (value?.is_elite) {
            elite.push(value);
        }
    }
    const elitePopular = sortByKey(elite, "luxuryDisplayOrder", "desc");

    return { all, popular, luxury, elite: elitePopular };
};
